import { CURRENCY_NAME, IsStableCoin } from '@/constants/currency';
import { isNumber } from 'lodash-es';

export const USDT_DECIMAL = 2;
export const OTHER_DECIMAL = 8;
export const getDecimal = (currency = CURRENCY_NAME.USDT, value?: number) => {
  if (IsStableCoin(currency)) {
    if (isNumber(value) && value < 1) {
      const match = String(value).match(/\.0+/);
      const zersCount = !match ? 0 : match[0].length - 1;
      return zersCount + 2;
    }
    return USDT_DECIMAL;
  } else {
    return OTHER_DECIMAL;
  }
};

export const getCrashDecimal = (currency = CURRENCY_NAME.USDT) => {
  if (IsStableCoin(currency)) {
    return 4;
  } else {
    return 8;
  }
};
export const getMinAmount = (currency) => {
  const zero = '0';
  const decimal = getCrashDecimal(currency);
  return Number('0.' + zero.repeat(decimal - 1) + '1');
};
